export default __webpack_public_path__ + "static/media/python.e6d7dc73.svg";